import React from 'react';
export const TermsOfService = () => {
  return <div className="pt-20" data-id="element-4800">
      <section className="py-16 bg-secondary/5" data-id="element-4801">
        <div className="container mx-auto px-4" data-id="element-4802">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4803">
            Terms of Service
          </h1>
          <p className="text-center text-secondary" data-id="element-4804">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-4805">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-4806">
          <div className="prose prose-lg max-w-none" data-id="element-4807">
            <p data-id="element-4808">
              Welcome to The Networking Salon — a community built on connection,
              trust, and growth. By joining our events, engaging with our
              network, or using our website, you're agreeing to these terms.
              They're here to set clear expectations so everyone can have a
              safe, respectful, and valuable experience.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4809">
              1. Our Promise to You
            </h2>
            <p data-id="element-4810">
              We're here to create spaces — online and offline — where
              meaningful professional relationships can grow. We commit to
              providing a respectful, inclusive, and inspiring environment for
              all our members.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4811">
              2. Your Part in the Community
            </h2>
            <p data-id="element-4812">By being part of The Networking Salon, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4813">
              <li data-id="element-4814">Show up with respect, professionalism, and curiosity.</li>
              <li data-id="element-4815">
                Treat fellow members with kindness, regardless of background,
                role, or opinion.
              </li>
              <li data-id="element-4816">
                Use our events and platforms to build genuine connections, not
                just to pitch or sell.
              </li>
              <li data-id="element-4817">
                Keep confidential conversations private, unless you've been
                given permission to share.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4818">
              3. Event Participation
            </h2>
            <p data-id="element-4819">When you attend our events, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4820">
              <li data-id="element-4821">
                Follow all event guidelines and venue/virtual platform rules.
              </li>
              <li data-id="element-4822">Respect others' time, space, and perspectives.</li>
              <li data-id="element-4823">
                Understand that we may capture photos or videos at events, which
                may be used for promotional purposes (you can opt out in writing
                if you prefer not to be included).
              </li>
            </ul>
            <p data-id="element-4824">
              We reserve the right to remove anyone whose behavior disrupts the
              safe and respectful spirit of the community.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4825">
              4. Payments & Refunds
            </h2>
            <p data-id="element-4826">Some of our events, memberships, or services require payment.</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4827">
              <li data-id="element-4828">
                Unless otherwise stated, tickets and fees are non-refundable,
                but we'll always try to accommodate transfers or credits if life
                gets in the way.
              </li>
              <li data-id="element-4829">
                If we cancel an event, you'll receive a full refund or credit.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4830">
              5. Intellectual Property
            </h2>
            <p data-id="element-4831">
              The Networking Salon's content, branding, and event materials
              belong to us. You're welcome to share what you've learned and
              experienced, but please don't copy or use our materials without
              permission.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4832">
              6. Liability & Expectations
            </h2>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4833">
              <li data-id="element-4834">
                We provide opportunities for connection, but we can't guarantee
                specific outcomes (like business deals or partnerships).
              </li>
              <li data-id="element-4835">
                We are not liable for any loss, damage, or injury connected to
                your participation in our events, website, or services.
              </li>
              <li data-id="element-4836">
                Participation is at your own discretion and responsibility.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4837">
              7. Updates to These Terms
            </h2>
            <p data-id="element-4838">
              We may update these terms occasionally. Any changes will be posted
              on our website, and by continuing to use our services, you agree
              to the updated version.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4839">8. Governing Law</h2>
            <p data-id="element-4840">
              These terms are governed by the laws of Nigeria, and any disputes
              will be resolved in the courts of Lagos.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4841">9. Contact Us</h2>
            <p data-id="element-4842">We're here for questions, clarifications, or feedback.</p>
            <p data-id="element-4843">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-4844">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};